import { ValidationInterface } from '../../validation.interface';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import { AdditionalProduct, AddProdPropName } from '../../../../models/project/plant-specifications/additional-product.model';

export class FinancialAdditionalProductValidation implements ValidationInterface {
  private readonly product: AdditionalProduct;

  constructor(product: AdditionalProduct) {
    if (!product) throw Error('invalid product provided for financial validation');
    this.product = new AdditionalProduct(product);
  }

  getValidation(): ProjectValidationUnit {
    if (!this.product) throw Error('unable to validate product financial');
    const validationUnit = new ProjectValidationUnit();

    validationUnit.addModuleResults(
      new UnitValueValidation(this.product.price).getValidation(),
      AddProdPropName.price
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.product.pricePer).getValidation(),
      AddProdPropName.pricePer
    );

    return validationUnit;
  }


  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
